import React, { useRef, useEffect, useState } from "react";
import { postData,getData } from "../../Service/ApiMethod";
import { Payment_sheet, Recharge_Credit,CREDIT_VALUE } from "../../Service/service";
import { useTranslation } from "react-i18next";
// import StripeCheckout from "react-stripe-checkout";

const CreditTopup = (props) => {
  const wrapperRef = useRef(null);
  const [credit, setCredit] = useState(0);
  const [creditValue, setCreditValue] = useState(0)
  const pay = Number(credit) / Number(10);
  // const [rechargeCredit, setRechargeCredit] = useState();
  // const [r, setR] = useState();
  const {t} = useTranslation();
  useOutsideAlerter(wrapperRef);

  const profile_Status = () => {
    getData(CREDIT_VALUE)
      .then((response) => response.json())
      .then((res) => {
        console.log("okkkkkkkk",res);
        setCreditValue(res.data.credit_value)
      })
      .catch((err) => {
        console.log("profileStatusErr", err);
      });
  };
  function useOutsideAlerter(ref) {

    useEffect(() => {
      profile_Status()
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          props?.closeModalWrtOutsideClick();
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }
  // const postRechargeCredit = (pay) => {
  //   const obj = {
  //     'available_credits': 200,
  //     'payment_mode':'paypal',
  //     'transaction_no': '000002',
  //     'success':'true',
  //     'price': pay,
  //   }
  
  //   postData(obj, Recharge_Credit)
  //     .then((response) => response.json())
  //     .then((data) =>  {
  //       // setRechargeCredit(data.data);
  //       console.log(data.data);
  //       alert(data.message)
  //     })
  //     .catch((err) => {
  //       console.log('Error', err);
  //     });
  //   };
    
  //   const handleToken = async(token)=>{
  //     console.log(token , "token")
  //     const obj = {
  //       email :token?.email
  //     }
  //    await postData(obj,Payment_sheet )
  //     .then(res => res.json())
  //     .then(data => {
  //       console.log("resp", data)
  //     })
  //   }



    const checkValss = () => {
      let obj = {
        serviceId: 1,
        subscription_id: props.subcriptionDetail.plan_id,
        txnAmount:  (creditValue*credit)*100,
        gateWayName: "card",
        paymentMode: 1,
        user_type: "RECRUITER"
      };
      window.fetch("https://api.catzapp.com/manage_plan_txn/", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("catzapp_token"),
        },
        body: JSON.stringify(obj),
      }).then((res) => {
        return res.json();
      }).then((data) => {
        console.log("sdeee", data.data.payment_intent.client_secret);
        localStorage.setItem("client_scrate",data.data.payment_intent.client_secret)
       
      });
    }








  return (
    <div className="blur-screen-full-area flex-center">
      <div className="flex-center flex-column coins-topup" ref={wrapperRef}>
        <h2 className="popup-heading">{t('Recharge Credit')}</h2>
        <p className="text">{t('Buy Credits to unlock the candidates')} </p>

        <div className="topup-range-box my-3">
          <div className="space-between d-flex">
            <p className="text">{t('Select No. of Credits')}</p>
            <p className="text">{Number(credit)} {t('credits')}</p>
          </div>

          <input
            type="range"
            name="credit" id="credit" className="w-100 mt-3"
            min="0"
            max="300"
            value={credit}
            style={{cursor:"pointer"}}
            onChange={(e) => { setCredit(e.target.value); e.preventDefault(); }}
          />
        </div>

        <button className="theme-btn mt-3 btn-block" value={pay} onClick={()=>{checkValss(pay);props.closePopup()}}>
          {t('Pay')}$ {(Math.round((credit*creditValue) * 100) / 100).toFixed(2)}
        </button>
        
         {/* <StripeCheckout
      token={handleToken}
      stripeKey="pk_test_51Mit3xSHOcHxqHqIfzTJRYb9g6e4xbgg2Lslsgf3NUj9YCKu76gMLqXpuGdV7loiSj9acoA0LolSGvYkVX5rWR3M00ZiG2ZWwx"
       name="Catzapp"
     
     
      label={t("Pay")}

      billingAddress={false}
      zipCode={true}
    /> */}
      </div>
    </div>
  );
};

export default CreditTopup;
